import { createStyles, makeStyles, Theme, Tooltip } from "@material-ui/core";
import { useMemo } from "react";
import { FONTS, SECONDARY_COLOR, THIRD_COLOR } from "../../../constants";
import { boundaryType, findBoundaries } from "../../../helpers/DataHelpers";
import { formatNumber } from "../../../helpers/FormatNumber";
import { stateType } from "../../../state";

export type pointType = {
	pcaPoint: number[];
	color: string;
	boundary: boundaryType;
	tooltip: string;
};

export let OTHER_COLOR = "#646DF0";
export let MULTI_COLOR = THIRD_COLOR;

export const CHART_COLORS = [
	// "#646DF0",
	"#DC6046",
	"#5CC89A",
	"#9F65EF",
	"#26697F",
	"#2F4858",
	"blue",
];
export const CHART_COLORS_HOVER = [
	"white",
	"white",
	"white",
	"white",
	"white",
	"white",
	"white",
];
const shadow = "0px 0px 2px 1px #fff";
export const CHART_SHADOW = CHART_COLORS.map((val) => "0px 0px 0px 0px #0ff");
export const CHART_SHADOW_HOVER = CHART_COLORS.map((val) =>
	shadow.replace("${color}", val)
);

const pointSize = "8px";

const AXIS_COLOR = "rgba(0,0,0,0.5)";
export let CHART_COLOR =
	"linear-gradient(to right top, #151515, #171718, #19191a, #1b1a1d, #1d1c1f, #1d1c22, #1d1d25, #1c1d28, #1a1b2c, #171a2f, #141833, #111636)";

export const TEXT_COLOR = "white";
// background-image: linear-gradient(to right top, #ffffff, #fcfaff, #faf4fe, #faeefc, #fce7f9, #f8e4fb, #f3e2fd, #ece0ff, #d2e5ff, #a6eeff, #75f6ff, #5ffbf1);

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		chart: {
			width: "93%",
			height: "73%",
			marginTop: "80px",
			alignSelf: "center",
			marginBottom: "-55px",
			backgroundColor: "rgba(0,0,0,0)",
			position: "relative",
		},
		tooltip: {
			backgroundColor: SECONDARY_COLOR,
			fontSize: "17px",
			color: "white",
			fontFamily: FONTS,
		},
		tooltipArrow: { color: SECONDARY_COLOR },
	})
);

export const ClusterChart = ({ state }: stateType) => {
	const classes = useStyles();

	// Get needed data
	const ndx = state.saveState.topicModeling.varSelected;
	const visData = state.saveState.dataset.visualizationData[ndx];
	const plotPoints = visData.customTopicsData.plotPoints;
	const groups = visData.customTopicsData.groups;
	const noTopicIndex = visData.customTopicsData.noTopicIndex;
	const multiTopicIndex = visData.customTopicsData.multiTopicIndex;
	let displaySentences = visData.customTopicsData.sentences;

	// if (plotPoints === undefined) {
	//   return <div></div>;
	// }

	const boundary = findBoundaries(plotPoints);

	return useMemo(
		() => (
			<div className={classes.chart}>
				{plotPoints.map((point, index) => (
					<Point
						pcaPoint={point}
						color={
							groups === undefined
								? OTHER_COLOR
								: groups[index] === noTopicIndex
								? OTHER_COLOR
								: groups[index] === multiTopicIndex
								? MULTI_COLOR
								: CHART_COLORS[groups[index]]
						}
						boundary={boundary}
						tooltip={displaySentences[index]}
					></Point>
				))}
				<AxisH boundary={boundary}></AxisH>
				<AxisV boundary={boundary}></AxisV>
				{/* <ConvexHullsOverlay state={state}></ConvexHullsOverlay> */}
			</div>
		),
		[plotPoints]
	);
};

export function convertPointCoord(
	point: number[],
	boundary: boundaryType,
	pad = 0
) {
	const xPercent =
		(100 * (point[0] - boundary.minX)) /
			Math.max(0.001, boundary.maxX - boundary.minX) -
		pad;
	const yPercent =
		(85 * (point[1] - boundary.minY)) /
			Math.max(0.001, boundary.maxY - boundary.minY) -
		pad;
	return {
		xPercent: formatNumber(xPercent) + "%",
		yPercent: formatNumber(yPercent) + "%",
	};
}

export const Point = ({ pcaPoint, color, boundary, tooltip }: pointType) => {
	const classes = useStyles();
	const converted = convertPointCoord(pcaPoint, boundary);

	return (
		<Tooltip
			title={tooltip}
			arrow
			placement="top"
			classes={{
				tooltip: classes.tooltip,
				arrow: classes.tooltipArrow,
			}}
		>
			<div
				style={{
					width: pointSize,
					height: pointSize,
					margin: "-" + pointSize,
					left: converted.xPercent,
					top: converted.yPercent,
					position: "relative",
					borderRadius: "50%",
					zIndex: 10,
					transition: "1s",
					// border: "solid",
					// borderWidth: "1px",
					backgroundColor: color,
					opacity: 0.7,
					// border: "solid",
					// borderWidth: "2px",
					// borderColor: "black",
				}}
			></div>
		</Tooltip>
	);
};

type axisType = { boundary: boundaryType };
function AxisH({ boundary }: axisType) {
	return (
		<div
			style={{
				top: "50%",
				width: "100%",
				height: "1px",
				color: TEXT_COLOR,
				backgroundColor: AXIS_COLOR,
				position: "relative",
				margin: "-1px",
				zIndex: 1,
			}}
		></div>
	);
}

function AxisV({ boundary }: axisType) {
	return (
		<div
			style={{
				left: "50%",
				width: "1px",
				height: "100%",
				color: TEXT_COLOR,
				backgroundColor: AXIS_COLOR,
				position: "relative",
				zIndex: 1,
			}}
		></div>
	);
}
